import axios from '@/axios'

const state = {}

const getters = {}

const mutations = {}

const actions = {
  checkVoucher({ commit }, { event, code }) {
    return axios
      .post(`/voucher/exists`, { code: code, event: event })
      .then(response => {
        return response.data
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
